// BOX NOW locker picker — opens the same widget the classic checkout uses
// (widget-v5 popup), listens for the locker postMessage, and returns the
// selected locker. Mirrors box-now-delivery/js/box-now-delivery.js.

const TRUSTED = /^https:\/\/.*\.boxnow\..*$/;

// BoxNow runs one widget host per country and each lists only that country's
// lockers — a Cypriot shopper sent to the .gr popup gets a map of Greece. Same
// mapping the plugin's own createPopupMap() uses.
const WIDGET_HOSTS = {
  CY: 'widget-v5.boxnow.cy',
  BG: 'widget-v5.boxnow.bg',
  HR: 'widget-v5.boxnow.hr',
};

export function openBoxNowWidget({ partnerId, postcode, gps, country }, onSelect) {
  // Already open? ignore.
  if (document.getElementById('cn-boxnow-iframe')) return;

  const host = WIDGET_HOSTS[String(country || '').toUpperCase()] || 'widget-v5.boxnow.gr';
  let src = `https://${host}/popup.html`;
  src += partnerId ? ('?partnerId=' + encodeURIComponent(partnerId) + '&') : '?';
  src += (gps === 'off')
    ? ('gps=no&zip=' + encodeURIComponent(postcode || '') + '&autoclose=yes&autoselect=no')
    : 'gps=yes&autoclose=yes&autoselect=no';

  const overlay = document.createElement('div');
  overlay.id = 'cn-boxnow-overlay';
  overlay.className = 'cn-boxnow-overlay';

  // The widget (widget-v5.boxnow.*) renders its own header/search/map/list.
  // Full-screen iframe + a floating close (the iframe covers the overlay, so
  // there's no click-outside to dismiss).
  const iframe = document.createElement('iframe');
  iframe.id = 'cn-boxnow-iframe';
  iframe.className = 'cn-boxnow-frame';
  iframe.src = src;
  iframe.allow = 'geolocation';

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'cn-boxnow-close';
  close.setAttribute('aria-label', 'Κλείσιμο');
  close.innerHTML = '✕';

  function cleanup() {
    window.removeEventListener('message', onMessage);
    overlay.remove();
    iframe.remove();
    close.remove();
  }

  function onMessage(e) {
    if (!TRUSTED.test(e.origin)) return;
    const data = e.data;
    if (data === 'closeIframe' || (data && typeof data === 'object' && data.boxnowClose !== undefined)) {
      cleanup();
      return;
    }
    if (data && typeof data === 'object' && data.boxnowLockerId !== undefined) {
      onSelect({
        id: String(data.boxnowLockerId),
        name: data.boxnowLockerName || '',
        address: data.boxnowLockerAddressLine1 || '',
        postcode: data.boxnowLockerPostalCode || '',
      });
      cleanup();
    }
  }

  overlay.addEventListener('click', cleanup);
  close.addEventListener('click', cleanup);
  window.addEventListener('message', onMessage);
  document.body.appendChild(overlay);
  document.body.appendChild(iframe);
  document.body.appendChild(close);
}
